











































































import {
  Component, Emit, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { cloneDeep, join, mapValues } from 'lodash';
import { Message } from 'element-ui';
import { BankAccount, DirectDebitMandate } from '@/api/payment-orders';
import BankAccountsModule from '@/store/bank-accounts';

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class PartyForm extends Vue {
  @Prop({
    type: Object,
    default: () => BankAccount.default(),
  })
  readonly party!: Partial<BankAccount>;

  @Prop({
    type: Boolean,
  })
  readonly hideIban!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly ibanOptional!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideSynesisCode!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideIsPayable!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideDirectDebitMandate!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly directDebitMandateRequired!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly synesisCodeRequired!: boolean;

  @Prop({
    type: Boolean,
  })
  readonly hideCreditorSchemeId!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly creditorSchemeIdRequired!: boolean;

  party_ = cloneDeep({
    ...this.party,
    directDebitMandate: this.party.directDebitMandate ?? new DirectDebitMandate(),
  });

  isLoading = false;

  @Watch('party', { deep: true })
  onPartyChange() {
    this.party_ = cloneDeep({
      ...this.party,
      directDebitMandate: this.party.directDebitMandate ?? new DirectDebitMandate(),
    });
  }

  get ibanRules() {
    if (this.ibanOptional) {
      return 'iban';
    }

    return 'required|iban';
  }

  get synesisCodeRules() {
    const rules = ['numeric'];

    if (this.synesisCodeRequired) {
      rules.push('required');
    }

    return join(rules, '|');
  }

  get mandateRules() {
    const rules = [];

    if (this.directDebitMandateRequired) {
      rules.push('required');
    }

    return join(rules, '|');
  }

  get creditorSchemeIdRules() {
    const rules = [];

    if (this.creditorSchemeIdRequired) {
      rules.push('required');
    }

    return join(rules, '|');
  }

  get form(): BankAccount {
    // otherwise, class-validator will fail when synesisCode etc existed and then is deleted
    return mapValues(this.party_, (value) => (value === '' || (value instanceof DirectDebitMandate && value.isEmpty) ? null : value)) as BankAccount;
  }

  get isEdit() {
    return Boolean(this.party.id);
  }

  async onSubmit() {
    this.isLoading = true;

    let newParty = null;
    try {
      if (this.form.id) {
        newParty = await BankAccountsModule.updateBankAccount(this.form);

        Message.success('Stranka uspješno ažurirana!');
      } else {
        newParty = await BankAccountsModule.saveBankAccount(this.form);

        Message.success('Stranka uspješno kreirana!');
      }

      this.$emit('submit', newParty);

      this.onClose();
    } catch (e) {
      console.error({ e });
      Message.error('Došlo je do pogreške prilikom kreiranja stranke! Provjerite postoji li već stranka s danim imenom, IBAN-om ili šifrom u Synesisu');
    } finally {
      this.isLoading = false;
    }
  }

  @Emit('cancel')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {
  }
}
